export interface IOptions extends RequestInit {
  cookie?: string | null;
  data?: any;
  headers?: any;
  method?: 'GET' | 'POST' | 'DELETE' | 'PUT';
  skipIntercept?: boolean; // 跳过拦截
  logger?: boolean; // 是否记录日志
}

export const logError = (
  level: string,
  url: string,
  method: string,
  error: any,
  data: any = null
) => {
  // 统一的日志记录格式
  const logEntry = {
    level,
    method,
    url,
    data,
    error: {
      message: error.message,
      stack: error.stack,
    },
    timestamp: new Date().toISOString(),
  };
  console.error(JSON.stringify(logEntry, null, 2));
};

const ignorePrevURI = ['https://', 'http://', '/ssvapi/'];

//
const hasIgnorePrevURI = (url: string) =>
  ignorePrevURI.some((s) => url.startsWith(s));

export const createFetch = async (url: string, options: IOptions) => {
  const PRE_URI =
    typeof window === 'undefined' ? process.env.NEXT_PUBLIC_APP_SERVER_URL : '';
  const isFromOtherApi = hasIgnorePrevURI(url);
  const _url = isFromOtherApi ? url : PRE_URI + url;

  const {
    cookie,
    headers: headerConfig,
    body: b,
    data,
    method,
    cache,
    ...otherProps
  } = options;

  const headers = {
    Cookie: cookie ?? undefined,
    ...(headerConfig || {}),
  };

  const body = b ? b : data ? JSON.stringify(data) : undefined;

  // 渲染策略：
  // - dev/test 环境：cache='no-store'，每次请求重新获取数据，跳过构建时 SSG prerender
  // - prod 环境：revalidate=60，走 ISR 静态渲染（构建时 prerender + 60秒增量更新）
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV;
  const isStaticRender = appEnv === 'production';

  // 如果调用方显式传了 cache（如 'no-store'），优先使用调用方的设置
  // 否则按环境自动决定
  const fetchOptions: RequestInit = {
    method: method || 'GET',
    credentials: 'include',
    body,
    headers,
    ...otherProps,
  };

  if (cache) {
    // 调用方显式指定了 cache 策略（如 no-store）
    fetchOptions.cache = cache;
  } else if (isStaticRender) {
    // 生产环境：ISR，60秒增量静态再生
    (fetchOptions as any).next = { revalidate: 60 };
  } else {
    // 开发/测试环境：不缓存，跳过 SSG prerender
    fetchOptions.cache = 'no-store';
  }

  try {
    const res = await fetch(_url, fetchOptions);
    return res;
  } catch (err) {
    // 记录错误日志，然后抛出而非返回 Error 对象
    // 返回 Error 对象会导致 Server→Client Component 序列化失败：
    // "Only plain objects can be passed to Client Components from Server Components"
    console.error('[createFetch Error]', _url, err);
    throw err;
  }
};
